import React from 'react'
import OtherPlanTools from '../../plan/OtherPlanTools'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3OtherPlanToolsPage() {
  return (
    <V3PlanRouteShell>
      {React.createElement(OtherPlanTools as any, { visualVariant: 'v3' })}
    </V3PlanRouteShell>
  )
}

